import React, { useState } from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function FieldInfo( { content , label=""} ) {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <div>
            {label}
            <IconButton
                size="large"
                aria-haspopup="true"
                aria-describedby={id}
                onClick={handleClick}
            >
                <InfoOutlinedIcon sx={{ color: '#1976d2' }} />
            </IconButton>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                // sx={{ maxWidth: 550 }}
            >
                <div style={{ margin: 8 }}>
                    {/* {content ? content : "No information available."} */}
                    <div dangerouslySetInnerHTML={{ __html: content ? content.toString() : "No information available."  }} />

                </div>
            </Popover>
        </div>
    );
}